<template>
  <v-app>
    <v-fade-transition>
      <template v-if="getConfig != undefined">
        <v-app-bar app :color="getConfig.background_color" flat dark>
          <v-img alt="Vuetify Logo" class="shrink mr-2" contain :src="getConfig.logo" transition="scale-transition" width="175" />
          <v-spacer></v-spacer>
          <v-btn text :href="getHome">
            <span class="ml-3">Sign In</span>
          </v-btn>
          <v-scale-transition mode="out-in">
            <template v-if="$route.path == '/newuser'">
              <v-btn outlined dark key="returningUser" :to="'/' + getParams">
                <span>Returning User</span>
              </v-btn>
            </template>
            <template v-else>
              <v-btn outlined dark key="newUser" :to="'/newuser' + getParams">
                <span>New User</span>
              </v-btn>
            </template>
          </v-scale-transition>
        </v-app-bar>
      </template>
    </v-fade-transition>

    <v-main>
      <v-slide-x-transition mode="out-in">
        <template v-if="$route.path != '/'">
          <v-btn text color="primary" :to="'/' + getParams" absolute style="z-index: 1">
            <v-icon>mdi-arrow-left</v-icon>
            Back
          </v-btn>
        </template>
      </v-slide-x-transition>

      <v-slide-x-transition mode="out-in">
        <router-view />
      </v-slide-x-transition>
    </v-main>
  </v-app>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "UserAssistance",
  data: function () {
    return {
      config: [],
    };
  },

  methods: {
    ...mapActions(["setHome", "setConfig", "setParams"]),
  },
  created() {
    var self = this;

    document.title = this.$route.meta.title;
    self.setParams({
      params: location.href.indexOf("?") > -1 ? location.href.substr(location.href.indexOf("?")) : "",
    });
    self.setHome();
    self.setConfig({
      site: location.href.substr(location.href.indexOf("?site=") + 16),
    });
  },
  computed: {
    ...mapGetters(["getConfig", "getHome", "getParams"]),
  },

  watch: {
    $route() {
      document.title = this.$route.meta.title;
    },
  },
};
</script>
